export const buildCheckoutSaleItem = ({
  productId,
  quantity,
  overridePrice,
  priceSource,
  discountType,
  discountValue,
  discountReasonId,
  miscDescription,
  miscBarcode,
}) => ({
  productId,
  quantity,
  ...(overridePrice != null ? { overridePrice } : {}),
  ...(priceSource ? { priceSource } : {}),
  ...(discountType ? { discountType } : {}),
  ...(discountValue != null ? { discountValue } : {}),
  ...(discountReasonId ? { discountReasonId } : {}),
  ...(miscDescription ? { miscDescription } : {}),
  ...(miscBarcode ? { miscBarcode } : {}),
});

export const buildCheckoutSaleItems = (cartItems = []) => cartItems.map(buildCheckoutSaleItem);
